/* ===========================================================
   Averex Labs — Reviews section + notification popup
   Sample/placeholder data — swap the JSON in
   snippets/averex-reviews-data.liquid with real reviews before launch.
=========================================================== */

function averexGetReviews() {
  const el = document.getElementById('averex-reviews-data');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return [];
  }
}

function averexStars(rating) {
  const full = Math.round(rating);
  return '★'.repeat(full) + '☆'.repeat(5 - full);
}

function averexInitials(name) {
  return name.trim().charAt(0).toUpperCase();
}

function averexRenderSection(reviews) {
  const container = document.getElementById('averex-review-section');
  if (!container || !reviews.length) return;

  const avg = reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length;

  const heading = container.dataset.heading || 'Customer Reviews';

  container.innerHTML = `
    <div class="averex-review-section__summary">
      <div class="averex-review-section__score">${avg.toFixed(1)}</div>
      <div class="averex-review-section__meta">
        <span class="averex-stars">${averexStars(avg)}</span>
        <span class="averex-review-section__count">${heading} · Based on ${reviews.length} reviews</span>
      </div>
    </div>
    <div class="averex-review-section__list">
      ${reviews.map(r => `
        <div class="averex-review-card">
          <div class="averex-review-card__avatar">${averexInitials(r.name)}</div>
          <div class="averex-review-card__body">
            <div class="averex-review-card__top">
              <span class="averex-review-card__name">${r.name}</span>
              <span class="averex-review-card__date">${r.date}</span>
            </div>
            <div class="averex-stars">${averexStars(r.rating)}</div>
            ${r.title ? `<div class="averex-review-card__title">${r.title}</div>` : ''}
            <div class="averex-review-card__text">${r.text}</div>
          </div>
        </div>
      `).join('')}
    </div>
  `;
}

function averexInitPopup(reviews) {
  const popup = document.getElementById('averex-review-popup');
  if (!popup || !reviews.length) return;

  let idx = 0;
  let dismissed = false;

  function show() {
    if (dismissed) return;
    const r = reviews[idx % reviews.length];
    idx++;
    popup.innerHTML = `
      <div class="averex-popup__avatar">${averexInitials(r.name)}</div>
      <div class="averex-popup__content">
        <div class="averex-popup__top">
          <span class="averex-popup__name">${r.name}</span>
          <button class="averex-popup__close" aria-label="Close" type="button">✕</button>
        </div>
        <div class="averex-popup__stars">${averexStars(r.rating)}</div>
        <div class="averex-popup__text">${r.text.length > 90 ? r.text.slice(0, 90) + '…' : r.text}</div>
        <div class="averex-popup__meta">${r.city} · ${r.date}</div>
      </div>
    `;
    popup.classList.add('is-visible');
    popup.querySelector('.averex-popup__close').addEventListener('click', hide);
    setTimeout(hide, 5500);
  }

  function hide() {
    popup.classList.remove('is-visible');
  }

  setTimeout(show, 2500);
  setInterval(show, 10000);
}

document.addEventListener('DOMContentLoaded', () => {
  const reviews = averexGetReviews();
  averexRenderSection(reviews);
  averexInitPopup(reviews);
});
